import React from "react";
import { TableCell } from "@mui/material";
import DataTable from "src/components/DataTable";

export default function SummaryDataTable({
  isLoading,
  data,
  itemPerPage,
  page,
  total,
  onPageClick,
  onItemPerPageChange,
  visibleColumns,
  getColumnLabel,
  enableItemPerPageOption,
}) {
  return (
    <DataTable
      isLoading={isLoading}
      rows={data}
      rowsPerPage={itemPerPage}
      page={page}
      total={total}
      onPageClick={onPageClick}
      handleItemPerPageChange={onItemPerPageChange}
      enableItemPerPageOption={enableItemPerPageOption}
      renderHeader={() => (
        <>
          {visibleColumns.map(([key]) => (
            <TableCell key={key} sx={{ minWidth: 120, py: 2 }}>
              {getColumnLabel(key)}
            </TableCell>
          ))}
        </>
      )}
      renderRow={(row) => (
        <>
          {visibleColumns.map(([key]) => (
            <TableCell key={key} sx={{ minWidth: 120, py: 2 }}>
              {row[key] !== undefined && row[key] !== null && row[key] !== ""
                ? row[key]
                : "-"}
            </TableCell>
          ))}
        </>
      )}
    />
  );
}
